import { ReactElement } from 'react';

import {
  SubscriptionPageContainer,
  PaymentPageProps,
} from '@backrs_ui/grow-ui/src/pages/Subscription/SubscriptionPageContainer';
import {
  selectIsFeatureFlagEnabled,
  FEATURE_FLAGS,
} from '@backrs_ui/grow-ui/src/redux/featureFlags/featureFlags';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { useFetchUserPermissionsQuery } from '@backrs_ui/grow-ui/src/redux/user/user.api';
import { PaywallPermissionList } from '@backrs_ui/grow-ui/src/redux/user/user.transformer';

type PaywalledRouteProps = Readonly<{
  children: ReactElement;
  requiredPermissions: PaywallPermissionList;
  paymentPageProps?: PaymentPageProps;
}>;

export const PaywalledRoute = ({
  children,
  requiredPermissions,
  paymentPageProps,
}: PaywalledRouteProps) => {
  const { data: userPermissions } = useFetchUserPermissionsQuery(undefined);

  const isGrowPaywallEnabled = useAppSelector(
    selectIsFeatureFlagEnabled(FEATURE_FLAGS.GROW_PAYWALL),
  );

  const hasRequiredPermissions = requiredPermissions.every(
    (permission: string) =>
      userPermissions?.[permission as keyof typeof userPermissions]?.allowed === true,
  );

  if (hasRequiredPermissions || !isGrowPaywallEnabled) {
    return children;
  }

  return <SubscriptionPageContainer {...paymentPageProps} />;
};
